import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { FieldPreviewComponent } from "../../field-preview.component";
import { Cid10Field } from "./cid10";

@Component({
    selector: "cid10",
    templateUrl: "./cid10.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Cid10Component extends FieldPreviewComponent implements OnInit, OnDestroy {
    constructor(private _changeDetector: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this.field.onChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((changed) => {
            this._changeDetector.detectChanges();
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get cid10Field() {
        return this.field as Cid10Field;
    }
}
